// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__YL6uQ","topBottomGutter":"Layout_topBottomGutter__3ekqy"};